import { useTranslation } from 'react-i18next'

import { Icon, IconButton } from '@ds'
import { DiamondAnimation } from '@shared'
import { InfoOverlayData, useOverlayActions } from '@store'

import { OverlayLayout } from '../OverlayLayout'
import styles from './InfoOverlay.module.scss'

export const InfoOverlay = ({
  title,
  description,
  image,
  icon,
  buttonText,
  hideCloseButton,
  onClose,
}: InfoOverlayData['payload']) => {
  const { t } = useTranslation()
  const onCloseDefault = useOverlayActions().hideOverlay

  return (
    <OverlayLayout>
      <div className={styles.modalContent}>
        {!hideCloseButton && <div className={styles.closeIcon} onClick={onCloseDefault}>
          <svg viewBox="0 0 20 20" fill="none">
            <line x1="3.8" y1="4.1" x2="15.9" y2="16.1" stroke="white" />
            <line x1="15.9" y1="3.9" x2="3.8" y2="15.9" stroke="white" />
          </svg>
        </div>}
        <div className={styles.imageWrapper}>
          <div className={styles.imageMotion}>
            <img src={image} className={styles.image} />
          </div>
        </div>
        <svg viewBox="0 0 199 183" fill="none" className={styles.diamond}>
          <DiamondAnimation optimized />
        </svg>
        <div className={styles.title}>{t(title)}</div>
        {description && (
          <div className={styles.description}>{t(description)}</div>
        )}
        <IconButton
          onClick={onClose || onCloseDefault}
          className={styles.button}
          leftIcon={<Icon name={icon} size="L" />}
          type="secondary"
        >
          <span className={styles.buttonText}>{t(buttonText)}</span>
        </IconButton>
      </div>
    </OverlayLayout>
  )
}
